import { useCampuses } from '@/store/org/hooks';
import { UserSet } from './user';
import type { Ministry } from '@/shared/types/ministry';
import type { MinistryRoleKey } from '@/store/org/types';

export function MinistryName({ id }: { id: string }) {
  const { lookup } = useCampuses();
  const campus = lookup[id];

  return <div>{campus?.data.name || ''}</div>;
}

export function MinistryRoleAssignees({
  item,
  role,
  render = 'item',
}: {
  item: Ministry;
  role: MinistryRoleKey;
  render?: 'text' | 'item';
}) {
  const ids = item.data.roles?.[role] || [];

  return <UserSet ids={ids} render={render} />;
}
